import React, { useState, useEffect, memo } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { MdOutlineArrowRightAlt } from '../../icons';
import './css/automatedCTA.scss';
import queryString from 'query-string';
import { getMasterDoctorData } from '../../../Store/actions';
import LazyImage from '../../CustomLibraries/LazyImage';
import { DEMO_USER_PICTURE } from '../../../common/common';
import { Skeleton } from '../../../skeleton/Skeleton';
const CtaSubscribeDoctorV1 = ({ data, onClickCallback, isSubscribed }) => {
  const [loader, setLoader] = useState(true);
  const [{ profile, profile_image, doctor_name, subtitle }, setDoctorData] = useState({
    profile: '',
    profile_image: '',
    doctor_name: '',
    subtitle: ''
  });
  const dispatch = useDispatch();
  const { pathname, search } = useLocation();
  const { id } = queryString.parse(search);
  useEffect(() => {
    dispatch(
      getMasterDoctorData(data.doctor_id, (res) => {
        const { profile, profile_image, doctor_name, subtitle } = res.data[0];
        setDoctorData({ profile, profile_image, doctor_name, subtitle });
        setLoader(false);
      })
    );

    return () => {};
  }, [data]);
  return (
    <div className="subsDocCTABox p-5 w-100 position-relative overflow-hidden shadow p-5 rounded-3">
      <div className="ctaCardBoxIn">
        <div className="ctaCardDrImg rounded overflow-hidden">
          <LazyImage
            src={profile_image ?? DEMO_USER_PICTURE}
            alt=""
            className="object-fit-cover w-100 h-100 float-start"
            fallback_image={DEMO_USER_PICTURE}
            logo
          />
        </div>
        <div className="ctaCardDetails text-start">
          <h4 className="fs-3 text-black fw-semibold mb-3 position-relative">
            {loader ? (
              <Skeleton variant="text" width={'80%'} height={25} />
            ) : (
              `Enjoyed this work by Dr. ${doctor_name ?? ''}?`
            )}
          </h4>
          <h6 className="fs-4 fw-medium text-dark mb-4">
            {loader ? (
              <Skeleton variant="text" width={'70%'} height={25} />
            ) : (
              `Everytime a new content from Dr. ${doctor_name ?? ''} is added, you will be notified`
            )}
          </h6>
          <button
            className="btn btn-secondary rounded fs-4 fw-medium  cursorPointer ctaLink d-flex align-items-center gap-2"
            disabled={isSubscribed}
            onClick={() =>
              onClickCallback(
                data?.id,
                data?.cta_type_id,
                data?.entity_id,
                data?.entity_value,
                3,
                pathname,
                id
              )
            }
          >
            {isSubscribed ? 'Subscribed' : 'Subscribe Now'}{' '}
            <MdOutlineArrowRightAlt customClass={'fs-4'} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default memo(CtaSubscribeDoctorV1);
